import api from './api';

export async function createResume(data) {
	const res = await api.post('/resumes', data);
	return res.data;
}

export async function getAllResumes(page = 1, limit = 10) {
	const res = await api.get('/resumes', { params: { page, limit } });
	return res.data;
}

export async function getResumeById(id) {
	const res = await api.get(`/resumes/${id}`);
	return res.data;
}

export async function updateResume(id, data) {
	const res = await api.put(`/resumes/${id}`, data);
	return res.data;
}

export async function deleteResume(id) {
	const res = await api.delete(`/resumes/${id}`);
	return res.data;
}

export async function duplicateResume(id) {
	const res = await api.post(`/resumes/${id}/duplicate`);
	return res.data;
}

export async function togglePublic(id) {
	const res = await api.put(`/resumes/${id}/toggle-public`);
	return res.data;
}

export async function getPublicResume(shareableLink) {
	const res = await api.get(`/resumes/public/${shareableLink}`);
	return res.data;
}


